
$(function() { //onready 
	// insertReadLater for "Bewaar" button
	$('.wrapper').on('click', 'a[title="Bewaar"]', function(){
		insertReadLater($(this).attr('id'));
	});
});


function displayTagLink(tag, id,spanTagClass, sendInsertMessage) {
	id = id.substr(4);
	
	if (sendInsertMessage) {
		var xmlhttp = new XMLHttpRequest();
		xmlhttp.open('GET','/ajax/tagsajax?mode=s&id='+id+'&tag='+escape(tag), true);
		xmlhttp.send();
	}
	
	return $('<div>').append(
		$('<input>', { type : 'hidden', value : tag }),
		$('<a>', { href: '?' + insertParam('search[mytags]',tag) }).append(
			$('<span>', { 'class' : spanTagClass, text : tag })
		),
		"<span class='remove'>x</span>"
	);
}

function insertParam(key, value) {
	var keyValuePairs = document.location.search.substr(1).split('&');
	var i=keyValuePairs.length;
	var x; 
	while (i--) {
		x = keyValuePairs[0].split('=');
		if (x[0]==key) {
			x[1] = value;
			keyValuePairs[0] = x.join('=');
			break;
		}
	}
	if (i<0) {
		keyValuePairs[0] = [key,value].join('=');
	}
	return keyValuePairs.join('&');
}

function removeTag(tag, id) {
	id = id.substr(4);
	
	var xmlhttp = new XMLHttpRequest();
	xmlhttp.open('GET','/ajax/tagsajax?mode=d&id='+id+'&tag='+escape(tag), true);
	xmlhttp.send();
}

function insertReadLater(id) {
	
	var element = $('#tag_'+id+' > input');
	
	if (element.val() == '') {
		var hasBewaar = false;
		var sibs = element.siblings('div');
		sibs.each(function() {
			if ($(this).children('input').val() == 'Bewaard') {
				hasBewaar = true;
			}
		});
		if (!hasBewaar) {
			element.val('Bewaard,');
		}
	} else {
		element.val(element.val()+',');
	}
	element.keyup();
}

function showRemoveAllTags(tagName) {
	var tagClass = '.'+tagName;
	var tagID = '#'+tagName;
	if ($(tagID).html() == "") {
		$(tagClass).show();
		$(tagID).html(" ");
	} else {
		$(tagClass).hide();
		$(tagID).html("");
	}
}


// Form href for the personal tags which can be simple tags or a time period.
// IN: tagName - name of the tag
//UIT: query string 
function fetchLinkPersonalTags(tagName) {
	
	tagName = tagName.toLowerCase();
	
	var dateObj = new Date();
	var formatCurrentDate = formatDate(dateObj);
	dateObj.setUTCDate(dateObj.getUTCDate()-1);
	var formatYesterdayDate = formatDate(dateObj);
	dateObj.setUTCDate(dateObj.getUTCDate()-1);
	var formatBeforeYesterday = formatDate(dateObj);
	dateObj.setUTCDate(dateObj.getUTCDate()-5);
	var formatSevenDaysAgo = formatDate(dateObj);

	var url = '/?searchperday=true&search%5Bpub_date%5D=>%3D%22';

	if (tagName == 'vandaag') {
		url += formatCurrentDate+'%20midnight%22%20<%3D%22now%22';
	} else if (tagName == 'gisteren') {
		url += formatYesterdayDate+'%20midnight%22%20<%3D%22'+formatCurrentDate+'%20midnight%22';
	} else if (tagName == 'eergisteren') {
		url += formatBeforeYesterday+'%20midnight%22%20<%3D%22'+formatYesterdayDate+'%20midnight%22';
	} else if (tagName == 'belangrijk') {
		url += formatSevenDaysAgo+'%20midnight%22%20<%3D%22now%22&search%5Bpriority%5D=%3E1';
	} else {
		url = "?tag="+tagName;
	}
	return url;
}
// -----IDD-MINIFY-SETTINGS
// ecmaVersion:11
// -----IDD-MINIFY-SETTINGS-DONE
